import { ReactComponent as AboutImage } from "../images/undraw_questions_g2px.svg"; // Replace with your SVG path

const AboutSection = () => {
  return (
    <section id="about" className="py-20 px-4 bg-base-100">
      <div className="grid grid-cols-1 md:grid-cols-2 items-center max-w-7xl mx-auto gap-10">
        {/* Left: Text */}
        <div className="text-center md:text-left space-y-6">
          <h2 className="text-3xl md:text-4xl font-bold text-base">Why Choose Us?</h2>
          <p className="text-base text-lg max-w-xl">
            At Digiscape, we help brands stand out by blending design, technology,
            and strategy. From launching modern websites to optimizing digital
            presence—we’re here to grow with you.
          </p>
          <p className="text-base text-base max-w-xl">
            We’re a team of digital marketers, designers, and developers obsessed
            with performance and pixel-perfect quality.
          </p>
        </div>

        {/* Right: SVG (hidden below 1085px) */}
        <div className="hidden [@media(min-width:1086px)]:flex justify-center relative">
          <AboutImage className="w-full max-w-md h-auto" />
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
